import React from "react";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", email: "", phone: "", message: "" });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="contact-section">
      <Helmet>
        <title>Kontakt - Lackfertighaus</title>
        <meta
          name="description"
          content="Kontaktieren Sie Lackfertighaus für professionelle Beratung zu Ausbauarbeiten und Finishing-Lösungen. Wir sind für Sie da."
        />
        <meta property="og:title" content="Kontakt - Lackfertighaus" />
        <link rel="canonical" href="https://lackfertighaus.com/contact" />
      </Helmet>

      <h1>Kontaktieren Sie uns</h1>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Unsere Kontaktdaten</h2>

          <div className="contact-item">
            <div className="contact-icon">
              <FaHome />
            </div>
            <div className="contact-item-content">
              <h3>Adresse</h3>
              <p>
                Karlplatz 5c,
                74737 Elsdorf,
                Deutschland
              </p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FaPhone />
            </div>
            <div className="contact-item-content">
              <h3>Telefon</h3>
              <p>+493455716202</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <div className="contact-item-content">
              <h3>E-Mail</h3>
              <p>lackfertighaus@hotmail.com</p>
            <p>   
            <a href="https://wa.me/493455716202" class="soc">WhatsApp</a>
          </p>
          <p>
            <a href="https://viber.me/493455716202" class="soc">Viber</a>
          </p>
          <p>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer" class="soc">
              Facebook
            </a>
          </p>
          <p>
            <a
              href="https://www.instagram.com/accounts/login/"
              target="_blank"
              rel="noopener noreferrer" class="soc">
              Instagram
            </a></p>
            </div>
          </div>

          <div className="admin-frame">
            <h3>Unternehmensdetails</h3>
            <p>Registernummer: 75700895</p>
            <p>Handelsregister: Amtsgericht Elsdorf</p>
            <p>Umsatzsteuer-ID: DE75700895</p>
            <p>Geschäftsführung: Anna Schmidt</p>
          </div>
        </div>

        <div className="checkout-form">
          <h2>Senden Sie uns eine Nachricht</h2>
          {submitted && (
            <div className="notification">
              Vielen Dank für Ihre Nachricht! Wir werden uns in Kürze bei Ihnen
              melden.
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">E-Mail</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Telefon</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Nachricht</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required></textarea>
            </div>

            <button type="submit" className="btn-primary">
              Nachricht senden
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
